import { TitleCasePipe } from '@angular/common';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Hospitalization {
  key: string;
  name: string;
  active: boolean;
  description: string;
  type: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    if (data && typeof data === 'string') {
      this.key = data;
      this.active = true;
      this.name = new TitleCasePipe().transform(data.replace('_', ' '));
      this.type = 'hospitalization';
    } else {
      this.key = data.key;
      this.name = data.name;
      this.active = data.active;
      this.description = data.description;
      this.type = data.type;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/hospitalizations/hospitalization.ts